// src/features/comboOfferSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiurl } from "../Constants";

// Thunk to fetch combo offer data
export const fetchComboOfferData = createAsyncThunk(
  "comboOffer/fetchData",
  async () => {
    const response = await axios.get(apiurl + "special_combo");
    return response.data.products;
  }
);

const comboOfferSlice = createSlice({
  name: "comboOffer",
  initialState: {
    comboOfferData: [],
    loading: false,
    status: "idle",
    addedToCart: false,
  },
  reducers: {
    handleAddToCart: (state, action) => {
      state.addedToCart = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchComboOfferData.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(fetchComboOfferData.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.comboOfferData = action.payload;
      })
      .addCase(fetchComboOfferData.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { handleAddToCart } = comboOfferSlice.actions;

export default comboOfferSlice.reducer;
